
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Rennes dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Rennes certifiée Google Partner, accompagne les entreprises rennaises pour accroître leur visibilité et gagner de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Rennes dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Rennes certifiée Google Partner, accompagne les entreprises rennaises pour accroître leur visibilité et gagner de nouveaux clients.",
        },
      ],
    };
  },
};
